module.exports = __webpack_public_path__ + "img/pic_ziyuan@2x.53388122.png";